import React, { Component } from 'react';
import Navbar from './Navbar'
import { StyleRoot } from 'radium';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import CustomDragPreview from '../Util/customDragPreview';

var dndBackend = TouchBackend({ enableMouseEvents: true })//TouchBackend;
if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
  dndBackend = HTML5Backend;
}


class ContentComponent extends Component {
  render() {
    return (
      <StyleRoot style={{ height: '100%' }}>
        <Navbar />
        {/*CUSTOMER DRAG PREVIEW FOR DRAG PREVIEWS*/}
        <CustomDragPreview />
        {this.props.children}
      </StyleRoot>
    );
  }
}

export default DragDropContext(dndBackend)(ContentComponent);




// WEBPACK FOOTER //
// ./src/App/MainClient/contentComponent.jsx